import { editorEnum } from 'src/model/editor/editorEnum'
import description from 'src/pages/create-new-chat-deprecated/components/description'

// Every showcase preset keeps its intro and ends with these two blocks, titled in the colour of
// the preset's own intro heading. The catalog id is left empty here: withFreshCatalogIds fills
// it in when a preset is applied, because the catalog's saved ordering is keyed by that id and
// must not be shared between pages.
const showcaseLearningBlocks = titleColor =>
  `<div class="simple-box-wrapper" style="background-position:center;background-size:cover;" background-image="" background-color="" background-type="" background-size="cover" size-type="SCALE_TO_FILL" use-image-overlay="" background-position="center" linear-value="" opacity="" overlay-color=""><div class="simple-box"><div class="column" flex-size="undefined"><div class="dynamic-list" data-type="continueLearning" data-template="Default" data-grid="4" data-collections="" data-catalog-id="" data-price-tag-active="false" data-cl-title="Pick up where you left off" data-cl-link-label="Your learning" data-cl-title-color="${titleColor}">&nbsp;</div></div></div></div><div class="simple-box-wrapper" style="background-position:center;background-size:cover;" background-image="" background-color="" background-type="" background-size="cover" size-type="SCALE_TO_FILL" use-image-overlay="" background-position="center" linear-value="" opacity="" overlay-color=""><div class="simple-box"><div class="column" flex-size="undefined"><h2><span style="color:${titleColor};">Catalog</span></h2><div class="dynamic-list" data-type="catalog" data-template="Default" data-grid="3" data-collections="" data-catalog-id="" data-price-tag-active="false">&nbsp;</div></div></div></div>`

const newCatalogId = () =>
  typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`

// Gives each catalog block in a preset's sections its own id, as inserting one in the editor does.
export const withFreshCatalogIds = sections =>
  sections.map(section =>
    section?.content?.html
      ? {
          ...section,
          content: {
            ...section.content,
            html: section.content.html.replace(
              /(data-type="catalog"[^>]*?data-catalog-id=")[^"]*(")/g,
              (match, before, after) => `${before}${newCatalogId()}${after}`,
            ),
          },
        }
      : section,
  )

export const templateDataShowCase = [
  {
    name: 'Grow',
    id: 0,
    path: 'sections',
    primaryColor: '#015FFB',
    font: 'Sora',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/grow.png',
    value: [
      {
        type: editorEnum.headerType,
        // Same hero header the backend gives a new showcase, so the default preset matches it.
        content: {
          type: 2,
          alignment: 'left',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/grow.png',
          description:
            'Explore our courses and build the skills to reach your learning goals.',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-image:url(https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/grow-discover.jpg);background-position:top-center;background-size:cover;" background-image="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/grow-discover.jpg" background-color="" background-type="" background-size="cover" size-type="SCALE_TO_FILL" use-image-overlay="" background-position="top-center" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color=""><div class="simple-box"><div class="column" flex-size="undefined"><h1 style="text-align:center;">&nbsp;</h1><h1 style="text-align:center;"><span style="color:hsl(0,0%,0%);"><span id="introduction-title">Discover, Learn, and Grow</span></span></h1><p style="text-align:center;" id="introduction-description"><span>Welcome to your learning journey!&nbsp;</span></p><p style="text-align:center;"><span>Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p><p style="text-align:center;">&nbsp;</p></div></div></div>${showcaseLearningBlocks(
            'hsl(0, 0%, 0%)',
          )}`,
        },
      },
    ],
  },
  {
    name: 'Elegant',
    id: 3,
    path: 'sections',
    primaryColor: '#947100',
    font: 'Barlow',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/elegant.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          alignment: 'left',
          type: 3,
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/elegant.png',
          description:
            'Explore our courses and build the skills to reach your learning goals.',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(46, 100%, 29%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p id="introduction-description"><span>Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
          </div>
        </div>
      </div>${showcaseLearningBlocks('hsl(46, 100%, 29%)')}`,
        },
      },
    ],
  },
  {
    name: 'Vibrant',
    id: 5,
    path: 'sections',
    font: 'Manrope',
    primaryColor: '#000000',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/vibrant.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          alignment: 'left',
          type: 2,
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/vibrant.jpg',
          description:
            'Explore our courses and build the skills to reach your learning goals.',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#dffd6e;background-position:'';background-size:'';" background-image="" background-color="#dffd6e" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h1 style="text-align:center;"><span style="color:hsl(0, 0%, 0%);" id="introduction-title">Discover, Learn, and Grow</span></h1>
            <p style="text-align:center;" id="introduction-description"><span>Welcome to your learning journey! This is your opportunity to gain valuable new skills, expand your knowledge, and explore fresh perspectives that can transform the way you think and grow. Through engaging, interactive content, you'll immerse yourself in a dynamic learning experience designed to be both meaningful and enjoyable.&nbsp;</span></p>
            <p style="text-align:center;"><span>Whether you're looking to deepen your expertise, develop practical abilities, or simply broaden your horizons, this journey will empower you with the insights and tools you need to succeed. Get ready to learn, explore, and evolve!</span></p>
          </div>
        </div>
      </div>${showcaseLearningBlocks('hsl(0, 0%, 0%)')}`,
        },
      },
    ],
  },
  {
    name: 'Classic',
    id: 1,
    path: 'sections',
    primaryColor: '#001B47',
    font: 'Questrial',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/classic.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          alignment: 'center',
          type: 1,
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/classic.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:;">
        <div class="simple-box">
            <div class="column">
                <h2><span style="color:hsl(217, 100%, 14%);">Discover, Learn, and Grow</span></h2>
                <p>Welcome to your learning journey! Gain new skills, expand your knowledge, and explore fresh perspectives. Engage with interactive content designed to help you learn in a meaningful and enjoyable way.</p>
            </div>
        </div>
    </div>${showcaseLearningBlocks('hsl(217, 100%, 14%)')}`,
        },
      },
    ],
  },
  {
    name: 'Minimal',
    id: 2,
    primaryColor: '#7346F1',
    path: 'sections',
    font: 'Lato',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/minimal.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          alignment: 'left',
          type: 3,
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/minimal.png',
          description:
            'Explore our courses and build the skills to reach your learning goals.',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(256, 86%, 61%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
              <p id="introduction-description"><span>Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
            </div>
          </div>
        </div>${showcaseLearningBlocks('hsl(256, 86%, 61%)')}`,
        },
      },
    ],
  },

  {
    name: 'Discover',
    id: 6,
    path: 'sections',
    primaryColor: '#0077B6',
    font: 'Nunito Sans',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/discover.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          alignment: 'center',
          type: 1,
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/discover.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span>🌍 </span><span style="color:hsl(201, 100%, 36%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p style="text-align:center;" id="introduction-description"><span style="color:hsl(201, 100%, 36%);">Welcome to your learning journey! Gain new skills, expand your knowledge, and explore fresh perspectives. Engage with interactive content designed to help you learn in a meaningful and enjoyable way.</span></p>
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/world-map.png" alt="">
            </div>
          </div>
        </div>
      </div>${showcaseLearningBlocks('hsl(201, 100%, 36%)')}`,
        },
      },
    ],
  },

  {
    name: 'Podcast',
    id: 8,
    path: 'sections',
    primaryColor: '#FF6B00',
    font: 'Inter',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/podcast.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          alignment: 'center',
          type: 1,
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/podcast.jpg',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#ffffff;background-image:none;background-position:center;background-size:cover;" background-image="" background-color="#ffffff" background-type="color" background-size="cover" size-type="cover" use-image-overlay="false" background-position="center" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(25, 100%, 50%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p id="introduction-description"><span style="color:hsl(222, 36%, 11%);">Welcome to your learning journey! Gain new skills, expand your knowledge, and explore fresh perspectives. Engage with interactive content designed to help you learn in a meaningful and enjoyable way.</span></p>
          </div>
        </div>
      </div>${showcaseLearningBlocks('hsl(25, 100%, 50%)')}`,
        },
      },
    ],
  },
  {
    name: 'Divine',
    id: 9,
    path: 'sections',
    primaryColor: '#c3a169 ',
    font: 'Lato',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/divine.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          alignment: 'left',
          type: 2,
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/divine.png',
          description:
            'Explore our courses and build the skills to reach your learning goals.',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(37, 43%, 59%);" id="introduction-title">Embrace Wisdom, Find Your Path</span></h2>
            <p id="introduction-description"><span>Growth begins with curiosity and a willingness to explore new perspectives. Whether you're seeking personal transformation, professional development, or a deeper understanding of the world around you, this collection is designed to guide you every step of the way.</span></p>
            <p><span>Through insightful lessons, practical strategies, and timeless wisdom, you'll gain the clarity and confidence to navigate your journey with purpose and fulfillment.</span></p>
          </div>
        </div>
      </div>${showcaseLearningBlocks('hsl(37, 43%, 59%)')}`,
        },
      },
    ],
  },
  {
    name: 'Playful',
    id: 10,
    path: 'sections',
    primaryColor: '#708800',
    font: 'Barlow',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/playful.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          alignment: 'center',
          type: 1,
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/playful.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 17%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
              <p style="text-align:center;" id="introduction-description"><span style="color:hsl(0, 0%, 17%);">Welcome to your learning journey! This is your opportunity to gain valuable new skills, expand your knowledge, and explore fresh perspectives that can transform the way you think and grow. Through engaging, interactive content, you'll immerse yourself in a dynamic learning experience designed to be both meaningful and enjoyable.</span></p>
              <p style="text-align:center;"><span style="color:hsl(0, 0%, 17%);">Whether you're looking to deepen your expertise, develop practical abilities, or simply broaden your horizons, this journey will empower you with the insights and tools you need to succeed. Get ready to learn, explore, and evolve!</span></p>
            </div>
          </div>
        </div>${showcaseLearningBlocks('hsl(0, 0%, 17%)')}`,
        },
      },
    ],
  },
  {
    name: 'Dynamic',
    id: 11,
    path: 'sections',
    primaryColor: '#116CFF',
    font: 'Saira',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/dynamic.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          alignment: 'center',
          type: 3,
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/dynamic.png',
          description:
            'Explore our courses and build the skills to reach your learning goals.',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 17%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p style="text-align:center;" id="introduction-description"><span style="color:hsl(0, 0%, 17%);">Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
            <div class="video-wrapper" id="intro-video">
              <video class="video-player" src="https://player.vimeo.com/progressive_redirect/playback/1038160884/rendition/720p/file.mp4?loc=external&amp;log_user=0&amp;signature=e3371f1c844e5717ebef8396e458b401366fbbb67b1778a783d56e38494ea377" aspectratio="16/9" controls="true" controlslist="nodownload">&nbsp;</video>
            </div>
          </div>
        </div>
      </div>${showcaseLearningBlocks('hsl(0, 0%, 17%)')}`,
        },
      },
    ],
  },
  {
    name: 'Ascent',
    id: 12,
    path: 'sections',
    primaryColor: '#131313',
    font: 'Inter',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/ascent.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          alignment: 'center',
          type: 3,
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/ascent.png',
          description:
            'Explore our courses and build the skills to reach your learning goals.',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#222424;background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="#292a2b" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(50, 100%, 50%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p id="introduction-description"><span style="color:hsl(0, 0%, 100%);">Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
          </div>
        </div>
      </div>${showcaseLearningBlocks('hsl(50, 100%, 50%)')}`,
        },
      },
    ],
  },
  {
    name: 'Momentum',
    id: 14,
    primaryColor: '#0453F1',
    path: 'sections',
    font: 'Space Grotesk',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/momentum.png',
    value: [
      {
        type: editorEnum.headerType,
        content: {
          alignment: 'left',
          type: 1,
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/momentum.png',
        },
      },
      {
        type: editorEnum.mainType,
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#0453f1;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#0453f1" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(37, 100%, 96%);" id="introduction-title">Join the Experience, Make It Unforgettable! 🚀</span></h2>
            </div>
          </div>
        </div><div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(220, 97%, 48%);" id="intro-subtitle">Dive in, Explore more</span></h2>
              <p id="introduction-description"><span><strong>Welcome to your learning journey!</strong> This is your opportunity to gain valuable new skills, expand your knowledge, and explore fresh perspectives that can transform the way you think and grow.&nbsp;</span></p>
              <p><span>Through engaging, interactive content, you'll immerse yourself in a dynamic learning experience designed to be both meaningful and enjoyable. Whether you're looking to deepen your expertise, develop practical abilities, or simply broaden your horizons, this journey will empower you with the insights and tools you need to succeed. Get ready to learn, explore, and evolve!</span></p>
            </div>
          </div>
        </div>${showcaseLearningBlocks('hsl(220, 97%, 48%)')}`,
        },
      },
    ],
  },
]
